import React from "react";
import { VACATION_REQUEST_STATUS_ID } from "../../configs/constants";
import DisplayAttachments from "../../modules/presence/components/DisplayAttachments.modal";

const ValidateModalContent = ({
  eventInfos = {},
  closeModal,
  accept,
  reject,
  displayAccept = true,
  displayRefuse = true
}) => {
  return (
    <div>
      <div className="my-4">
        <span className="font-bold">Demande : </span>
        <span className="text-red-500">{eventInfos.duration || "N/C"}</span>
      </div>
      <div className="my-4">
        <span className="font-bold">Etat de la demande de congé : </span>
        {eventInfos.type === VACATION_REQUEST_STATUS_ID.PENDING && <span className="">En attente de validation</span>}
        {eventInfos.type === VACATION_REQUEST_STATUS_ID.VALIDATED && <span className="">Validée</span>}
        {eventInfos.type === VACATION_REQUEST_STATUS_ID.CANCELED && <span className="">Annulée</span>}
        {eventInfos.type === VACATION_REQUEST_STATUS_ID.REJECTED && <span className="">Rejetée</span>}
      </div>
      <div className="my-4">
        <span className="font-bold">Demande de type : </span>
        <span className="text-orange font-bold">{eventInfos.title || "N/C"}</span>
      </div>
      <div className="mt-6 text-center">
        {/* Pièce jointe quand connectée avec PeopleDoc
        <div className="cursor-pointer px-4 py-2 mx-auto w-1/2 leading-5 rounded-full bg-orange-500 text-white">
          Téléchargez la pièce jointe
        </div>
        <div className="text-gray-500 text-small text-center mt-2">justificatif_absence.pdf</div> */}
      </div>
      <div className="mt-6 flex justify-center">
        {displayRefuse && (
          <div
            className="cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full bg-red-500 text-white"
            onClick={() => {
              closeModal();
              reject(eventInfos);
            }}
          >
            Refuser le congé
          </div>
        )}
        {displayAccept && (
          <div
            className="cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full bg-green-400 text-white"
            onClick={() => {
              closeModal();
              accept(eventInfos);
            }}
          >
            Accepter le congé
          </div>
        )}
      </div>
      <DisplayAttachments attachments={eventInfos.attachments} />
    </div>
  );
};
export default ValidateModalContent;



// WEBPACK FOOTER //
// src/components/presence/ValideModalContent.js